import React, { useState } from "react";
import "./Setting.css";
// Component
import Holiday from "../../components/setting/Holiday";
import ConfigurationFileUpload from "../../components/setting/ConfigurationFileUpload";
// import Exceptional from '../../components/setting/Exceptional'
// Datepick
import ja from "date-fns/locale/ja";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { FiDownload } from "react-icons/fi";
import { resetAuth } from "../../features/auth/authSlice";
import { toast } from "react-toastify";
import { orikamiDomain } from "../../features/urlConst/domainUrl";

const Setting = () => {
  // redux
  const dispatch = useDispatch();
  const { user_info, token } = useSelector((state) => state.auth);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const downloadFile = async (e) => {
    e.preventDefault();
    try {
      const year = Number(moment(selectedDate).format("YYYY"));
      const month = Number(moment(selectedDate).format("M"));
      const data = {
        year,
        month,
      };

      const response = await fetch(
        orikamiDomain + "/api/v1/order/receipt_history",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            // Add any additional headers if needed
          },
          body: JSON.stringify(data),
        }
      );

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.description);
      }

      // Decode base64 and create a Blob
      const blob = new Blob(
        [
          Uint8Array.from(atob(responseData.value.file_data), (c) =>
            c.charCodeAt(0)
          ),
        ],
        { type: "application/octet-stream" }
      );

      // Create a download link
      const downloadLink = document.createElement("a");
      const url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = responseData.value.file_name;

      // Trigger the download
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // Clean up
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error?.message);
      console.error("Error downloading files:", error.message);
      if (
        error?.message === "expired token" ||
        error?.description === "expired token"
      ) {
        dispatch(resetAuth());
      }
    }
  };

  return (
    <div className="w-full mb-8">
      <h1 className="text-center my-4 text-2xl leading-snug uppercase">設定</h1>

      {user_info?.auth === 3 ? (
        <div className="w-full flex flex-col px-2">
          <h1 className="font-semibold py-2">領収書ダウンロード :</h1>
          <form
            onSubmit={downloadFile}
            className="w-full flex justify-start items-center gap-2"
          >
            <div>
              <DatePicker
                className="w-min h-[36px] rounded-[8px] outline-none focus:outline-none border-2 border-primary px-2 py-[2px]"
                selected={selectedDate}
                dateFormat="yyyy/MM"
                showMonthYearPicker
                locale={ja}
                onChange={(date) => setSelectedDate(date)}
              />
            </div>
            <button
              type="submit"
              className="w-[177px] h-[36px] flex justify-center items-center px-4 py-[2px] border-2 border-primary bg-primary text-white font-semibold rounded-[8px]"
            >
              <span className="font-bold text-white pr-2 text-[20px]">
                <FiDownload />
              </span>
              ダウンロード
            </button>
          </form>
        </div>
      ) : null}

      <Holiday />

      {/* <Exceptional /> */}

      <ConfigurationFileUpload />
    </div>
  );
};

export default Setting;
